import React from 'react'
import Reports from '../../components/reports/Reports'
const MainReports = () => {
    return (
        <div>
            <Reports />
        </div>
    )
}

export default MainReports
